import Comment from './Comment';
import { styled } from '@mui/material/styles';
import RepliesOfComment from './RepliesOfComment';

export const CommentsContainer = styled('ul')({
  display: 'flex',
  padding: '0',
  margin: '0',
  listStyle: 'none',
  flexDirection: 'column',
  '& li ul': {
    padding: '0 0 0 40px',
  },
});

export default function Comments({
  noteId,
  noteAuthorId,
  parentComments,
  childComments,
  replyComment,
}) {
  return (
    <CommentsContainer>
      {parentComments.map((parentComment) => {
        return (
          <li key={parentComment.id}>
            <Comment
              noteId={noteId}
              noteAuthorId={noteAuthorId}
              commentId={parentComment.id}
              commentProps={parentComment}
              isParent={true}
              replyComment={replyComment}
            />
            <RepliesOfComment
              noteId={noteId}
              noteAuthorId={noteAuthorId}
              childComments={childComments}
              parentId={parentComment.id}
              replyComment={replyComment}
            />
          </li>
        );
      })}
    </CommentsContainer>
  );
}
